import React from 'react';
import { Link } from 'react-router-dom';

/**
 * UXC — wspólny pasek tabów Społeczności (był zduplikowany ×3 w Feed/Friends/Listings).
 * `active`: 'feed' | 'friends' | 'gielda'. Dodane aria-current="page" na aktywnym (wymóg SD4/UXC).
 */
const TABS = [
  { k: 'feed', l: 'Aktywność', to: '/feed' },
  { k: 'friends', l: 'Znajomi', to: '/znajomi' },
  { k: 'gielda', l: 'Giełda', to: '/gielda' },
];

export default function CommunityTabs({ active }) {
  return (
    <div style={{ display: 'flex', gap: 6, marginBottom: 24, borderBottom: '1px solid var(--t-line)', paddingBottom: 12 }}>
      {TABS.map(t => {
        const on = t.k === active;
        return (
          <Link
            key={t.k}
            to={t.to}
            aria-current={on ? 'page' : undefined}
            style={{
              padding: '8px 14px',
              borderRadius: 8,
              background: on ? 'var(--t-sage-bg)' : 'transparent',
              border: `1px solid ${on ? 'var(--t-sage-bo)' : 'var(--t-line-2)'}`,
              color: on ? 'var(--t-sage)' : 'var(--t-text-dim)',
              fontSize: 13,
              fontFamily: 'var(--t-sans)',
              textDecoration: 'none',
              transition: 'background 200ms ease, border-color 200ms ease',
            }}
            onMouseEnter={e => { if (!on) { e.currentTarget.style.background = 'var(--t-dim-bg)'; e.currentTarget.style.borderColor = 'var(--t-line)'; } }}
            onMouseLeave={e => { if (!on) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'var(--t-line-2)'; } }}
          >
            {t.l}
          </Link>
        );
      })}
    </div>
  );
}
